import { GroupConfigurationCategoryFilter } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'
import { LastActivityType } from '@/modules/group/modules/groups/domain/models/LastActivityType'
import { Pagination } from '@/modules/shared/schemas/Pagination'

import { axios, Response } from '../index'

export default async function lastActivity({
  page,
  size,
  category,
  unread,
  name
}: {
  page: number
  size: number
  category?: GroupConfigurationCategoryFilter
  unread?: boolean
  name?: string
}): Response<Pagination<LastActivityType[]>> {
  const searchParams = new URLSearchParams()
  searchParams.set('page', page.toString())
  searchParams.set('size', size.toString())
  if (category) searchParams.set('category', category.toString())
  if (unread) searchParams.set('unread', unread.toString())
  if (name) searchParams.set('name', name.toString())

  return await axios.get(`/v1/groups-activities?${searchParams.toString()}`)
}
